import styled from 'styled-components';

import { AppCaption } from '@/components/AppCaption';
import { AppIcon } from '@/components/AppIcon';
import { AppName } from '@/components/AppName';
import { webCampaign } from '@/modules/webCampaign';

import LureLogo from './LureLogo.svg?react';
import LureLogoWhite from './LureLogoWhite.svg?react';

const LogoWithAppNameStyles = styled.section<{
  withBg: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  ${({ withBg }) =>
    withBg &&
    `
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.10);
    backdrop-filter: blur(5px);
    will-change: backdrop-filter, background;
    padding: 9px 12px;
  `}
`;

const TextStyles = styled.section`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
`;

export const LogoWithAppName: React.FC<{
  withCaption?: boolean;
  withBg?: boolean;
  className?: string;
  variant?: 'default' | 'white';
}> = ({
  withCaption = true,
  withBg = false,
  className,
  variant = 'default',
}) => {
  if (webCampaign.isLure()) {
    const LureLogoComponent = variant === 'white' ? LureLogoWhite : LureLogo;
    return (
      <LogoWithAppNameStyles withBg={withBg} className={className}>
        <LureLogoComponent />
      </LogoWithAppNameStyles>
    );
  }

  return (
    <LogoWithAppNameStyles withBg={withBg} className={className}>
      <AppIcon />
      <TextStyles>
        <AppName />
        {withCaption && <AppCaption />}
      </TextStyles>
    </LogoWithAppNameStyles>
  );
};
